import {css, cx} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {navigationHeight} from "@pg-rp/navigation";

import {PinState} from "../types/pin_state";

interface WrapperProps {
    navigationState: PinState;
    isMounted: boolean;
    children: React.ReactNode;
    ref?: React.Ref<HTMLDivElement>;
}

export const Wrapper = ({navigationState, isMounted, children, ref}: WrapperProps) => {
    return (
        <div ref={ref} className={cx(wrapperBaseStyle, isMounted && navigationState !== "unfixed" && wrapperStickyStyle, getWrapperTopStyle(navigationState))}>
            {children}
        </div>
    );
};

interface WideContentStyledProps {
    navigationState: PinState;
    isInvestment?: boolean;
    children: React.ReactNode;
}

export const WideContentStyled = ({isInvestment, children}: WideContentStyledProps) => {
    return <WideContent className={cx(wideContentBaseStyle, isInvestment && wideContentInvestmentStyle)}>{children}</WideContent>;
};

const wrapperBaseStyle = css({
    top: 0,
    zIndex: 22,
    transition: "top 200ms ease-in-out",
    paddingBottom: 0,
    md: {
        top: "initial",
        zIndex: "initial",
        height: "initial",
        paddingBottom: "initial",
        marginBottom: "initial",
        position: "initial"
    }
});

const wrapperStickyStyle = css({
    position: "sticky"
});

const getWrapperTopStyle = (navigationState: PinState) => {
    switch (navigationState) {
        case "pinned":
            return wrapperPinnedStyle;
        case "unpinned":
            return wrapperUnpinnedStyle;
        case "unfixed":
        default:
            return wrapperUnfixedStyle;
    }
};

const wrapperPinnedStyle = css({
    top: `${navigationHeight}px`
});

const wrapperUnpinnedStyle = css({
    top: `calc(-${navigationHeight}px + 1rem)`
});

const wrapperUnfixedStyle = css({
    top: 0
});

const wideContentBaseStyle = css({
    pb: 1.5,
    transition: "top 200ms ease-in-out",
    boxShadow: "var(--shadow-4)",
    backgroundColor: "var(--colors-white)",
    position: "relative",
    width: "100%",
    marginLeft: "initial",
    marginRight: "initial",
    maxWidth: "initial",

    md: {
        backgroundColor: "initial",
        boxShadow: "var(--shadow-0)",
        maxWidth: "var(--grid-md-widthPx)",
        marginLeft: "auto",
        marginRight: "auto",
        position: "initial"
    },

    lg: {
        maxWidth: "var(--grid-lg-widthPx)"
    }
});

const wideContentInvestmentStyle = css({
    md: {
        marginBottom: 0,
        paddingBottom: 0
    }
});
import {css, cx} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {navigationHeight} from "@pg-rp/navigation";

import {PinState} from "../types/pin_state";

interface WrapperProps {
    navigationState: PinState;
    isMounted: boolean;
    children: React.ReactNode;
    ref?: React.Ref<HTMLDivElement>;
}

export const Wrapper = ({navigationState, isMounted, children, ref}: WrapperProps) => {
    return (
        <div ref={ref} className={cx(wrapperBaseStyle, isMounted && navigationState !== "unfixed" && wrapperStickyStyle, getWrapperTopStyle(navigationState))}>
            {children}
        </div>
    );
};

interface WideContentStyledProps {
    navigationState: PinState;
    isInvestment?: boolean;
    children: React.ReactNode;
}

export const WideContentStyled = ({isInvestment, children}: WideContentStyledProps) => {
    return <WideContent className={cx(wideContentBaseStyle, isInvestment && wideContentInvestmentStyle)}>{children}</WideContent>;
};

const wrapperBaseStyle = css({
    top: 0,
    zIndex: 22,
    transition: "top 200ms ease-in-out",
    paddingBottom: 0,
    md: {
        top: "initial",
        zIndex: "initial",
        height: "initial",
        paddingBottom: "initial",
        marginBottom: "initial",
        position: "initial"
    }
});

const wrapperStickyStyle = css({
    position: "sticky"
});

const getWrapperTopStyle = (navigationState: PinState) => {
    switch (navigationState) {
        case "pinned":
            return wrapperPinnedStyle;
        case "unpinned":
            return wrapperUnpinnedStyle;
        case "unfixed":
        default:
            return wrapperUnfixedStyle;
    }
};

const wrapperPinnedStyle = css({
    top: `${navigationHeight}px`
});

const wrapperUnpinnedStyle = css({
    top: `calc(-${navigationHeight}px + 1rem)`
});

const wrapperUnfixedStyle = css({
    top: 0
});

const wideContentBaseStyle = css({
    pb: 1.5,
    transition: "top 200ms ease-in-out",
    boxShadow: "var(--shadow-4)",
    backgroundColor: "var(--colors-white)",
    position: "relative",
    width: "100%",
    marginLeft: "initial",
    marginRight: "initial",
    maxWidth: "initial",

    md: {
        backgroundColor: "initial",
        boxShadow: "var(--shadow-0)",
        maxWidth: "var(--grid-md-widthPx)",
        marginLeft: "auto",
        marginRight: "auto",
        position: "initial"
    },

    lg: {
        maxWidth: "var(--grid-lg-widthPx)"
    }
});

const wideContentInvestmentStyle = css({
    md: {
        marginBottom: 0,
        paddingBottom: 0
    }
});
